module.exports = __webpack_public_path__ + "static/not-found-05afe7a3261c48d8b9c461a4b759dea7.jpg";